
import { Component, Vue } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { getAccountId, getCampaignId } from '@/service/storage'
import { RootStateMutations } from '@/store/mutations'
import References from '@/api/models/References'
import CampaignReferences from '@/api/models/CampaignReferences'
import { hasPendingRedirect, redirectToRouteOnce } from '@/service/navigation'
import { normalizeError } from '@/service/error'

@Component({})
export default class StorageMixin extends Vue {
    @Getter('currentCampaign')
    readonly campaign!: number

    @Getter('currentAccount')
    readonly account!: number

    @Getter('references')
    references!: References

    @Getter('campaignReferences')
    campaignReferences!: CampaignReferences

    @Action('loadReferences')
    loadReferences!: () => Promise<void>

    @Action('loadCampaignReferences')
    loadCampaignReferences!: () => Promise<void>

    async created (): Promise<void> {
        if (hasPendingRedirect()) {
            return
        }

        if (!this.account) {
            const accountId = getAccountId() || 0
            if (!accountId) {
                await redirectToRouteOnce(this.$router, { name: 'accounts' })
                return
            } else {
                this.$store.commit(RootStateMutations.setAccount, accountId)
            }
        }

        if (hasPendingRedirect()) {
            return
        }

        if (!this.campaign) {
            const campaignId = getCampaignId() || 0
            if (!campaignId) {
                await redirectToRouteOnce(this.$router, { name: 'account_campaigns' })
                return
            }

            this.$store.commit(RootStateMutations.setCampaign, campaignId)
        }

        if (hasPendingRedirect()) {
            return
        }

        try {
            await this.getSystemReferences()

            if (hasPendingRedirect()) {
                return
            }

            await this.getCampaignReferences()
        } catch (err) {
            if (normalizeError(err).isAuthError) {
                await redirectToRouteOnce(this.$router, '/')
                return
            }

            throw err
        }
    }

    async getSystemReferences (): Promise<void> {
        if (!this.references.loaded) {
            await this.loadReferences()
        }
    }

    async getCampaignReferences (): Promise<void> {
        if (!this.campaignReferences.loaded) {
            await this.loadCampaignReferences()
        }
    }
}
